import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/UI/Buttons/buttons';
import css from '../styles.module.scss';
import { ReactComponent as EmptySvg } from '../icons/empty.svg';

interface IEmptyProps {
  openModal: ()=>void;
  text: string;
  isDisable: boolean;
}

const Empty: FC<IEmptyProps> = ({ openModal, text, isDisable}) => {
  const { t } = useTranslation();
  return (
    <div className={css.empty}>
      <EmptySvg />
      <div className={css.empty_text}>{text}</div>
      <Button
        title={t(`campaigns_page.create_btn`)}
        height={36}
        buttonAttributes={{
          onClick: openModal,
          disabled: isDisable,
        }}
      />
    </div>
  );
};

export default Empty;
